module.exports = __webpack_public_path__ + "img/error-01.29dafaed.png";